module.exports = __webpack_public_path__ + "nf.svg?5ddb43a9702d34f903b9b6bded8efda0";